import { Check } from "@vibe/icons";
import React from "react";
import ButtonComponent from "../../components/Button";
import { useNavigate } from "react-router-dom";

import useMondayContext from "@hooks/context/useMondayContext";

const WelcomePage = () => {
  const navigate = useNavigate();
  const { appFeatureType } = useMondayContext();

  const handleTour = (value: boolean) => {
    if (appFeatureType === "AppFeatureItemMenuAction") {
      navigate("/board-item-menu");
    } else if (appFeatureType === "AppFeatureItemBatchAction") {
      navigate("/batch-items-menu");
    } else if (appFeatureType === "AppFeatureBoardView") {
      navigate("/resynchronization");
    } else if (appFeatureType === "AppFeatureBoardColumnExtension") {
      navigate("/add-column");
    } else if (appFeatureType === "AppFeatureDialog") {
      navigate("/boards-dialog");
    } else {
      navigate("/", { state: { tour: value } });
    }
  };

  // const handleStart = () => {
  //   if (appFeatureType === "AppFeatureItemMenuAction") {
  //     navigate("/board-item-menu");
  //   } else if (appFeatureType === "AppFeatureItemBatchAction") {
  //     navigate("/batch-items-menu");
  //   } else if (appFeatureType === "AppFeatureBoardView") {
  //     navigate("/resynchronization");
  //   } else {
  //     navigate("/");
  //   }
  // };

  return (
    <section>
      <div className="flex items-center justify-center w-full min-h-[225px] welcome-page-hero">
        <div className="w-[72px] h-[72px] flex items-center bg-white justify-center shadow-welcome-check rounded-full">
          <Check size={46} color="#329E7B" />
        </div>
      </div>

      <div className="py-5">
        <div className="mx-auto text-center max-w-[600px]">
          <div className="mb-4">
            <h3 className="!font-figtree font-semibold">Welcome aboard!</h3>
            <p className="!font-figtree text-sm !mt-2">
              Thank you for installing the SIMB, we’re excited to have you on board! <br />
              {appFeatureType === "AppFeatureItemView" &&
                "Click on “Start Guided Tour” to get to know SIMB"}
            </p>
          </div>

          <div className="flex gap-4 justify-center items-center mx-auto mt-1">
            {appFeatureType === "AppFeatureItemView" && (
              <ButtonComponent onClick={() => handleTour(false)} text="Skip Tour" kind="tertiary" />
            )}

            <ButtonComponent
              onClick={() => handleTour(true)}
              text={`${appFeatureType === "AppFeatureItemView" ? "Start Guided Tour" : "Start"}`}
            />
            {/* 
            <ButtonComponent onClick={() => handleStart()} text="Start" kind="primary" /> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WelcomePage;
